<div class="modern-shared-dialog" [class.delete-dialog]="isDeleteDialog">
  <button type="button" class="close-btn" (click)="onDismiss()" *ngIf="isDeleteDialog">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <div class="modern-shared-dialog__header" *ngIf="isDeleteDialog">
    <h2>{{ title }}</h2>
  </div>

  <div class="modern-shared-dialog__content" *ngIf="!isDeleteDialog">
    <p class="message">{{ message }}</p>
  </div>

  <div class="modern-shared-dialog__content delete-content" *ngIf="isDeleteDialog">
    <p class="subtitle">{{ deleteSubtitle }}</p>
    <div class="file-block">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="pdf-icon">
        <path d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span class="file-name">{{ deleteFilename }}</span>
    </div>
  </div>

  <div class="modern-shared-dialog__actions" [class.has-divider]="isDeleteDialog">
    <button
      *ngIf="no !== 'logout'"
      type="button"
      class="cancel-text-btn"
      [class.outline-btn]="isDeleteDialog"
      (click)="onDismiss()"
    >
      {{ no }}
    </button>
    <button
      type="button"
      class="confirm-submit-btn"
      (click)="onConfirm()"
    >
      <svg *ngIf="isDeleteDialog" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="animated-bin">
        <path d="M3 6h18M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="bin-lid"/>
        <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6M10 11v6M14 11v6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="bin-body"/>
      </svg>
      {{ yes }}
    </button>
  </div>
</div>
